import CollectionPayload from '@libraries/api/user';
import CountryPayload from '@libraries/api/country';
import ProvincePayload from '@libraries/api/province';
import CityPayload from '@libraries/api/city';
import FetchData from '@utils/fetch-data';
import { notification } from 'antd';
import { history, IFetchData, initialList } from 'asumsi-components';
import { Dispatch, SetStateAction, useState } from 'react';
import { IResponseMasterUser } from '@interfaces/iresponse-user';
import { IResponseCountry } from '@interfaces/iresponse-country';
import { IResponseCity } from '@interfaces/iresponse-city';
import { IResponseProvince } from '@interfaces/iresponse-province';

const initialData = initialList.data;
const initialMeta = initialList.meta;
const defaultPage: number = 1;

export default function useAction() {
    const [isLoader, setIsLoader]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(false);

    const [data, setData]: [
        IResponseMasterUser[],
        Dispatch<SetStateAction<IResponseMasterUser[]>>,
    ] = useState(initialData);

    const [countries, setCountries]: [
        IResponseCountry[],
        Dispatch<SetStateAction<IResponseCountry[]>>,
    ] = useState(initialData);

    const [provinces, setProvinces]: [
        IResponseProvince[],
        Dispatch<SetStateAction<IResponseProvince[]>>,
    ] = useState(initialData);

    const [cities, setCities]: [
        IResponseCity[],
        Dispatch<SetStateAction<IResponseCity[]>>,
    ] = useState(initialData);

    const [metaData, setMeta]: [
        any,
        Dispatch<SetStateAction<any>>,
    ] = useState(initialMeta);

    const [detail, setDetail]: [
        any,
        Dispatch<SetStateAction<any>>,
    ] = useState();

    const getData = async (params: any) => {
        const payload: IFetchData = CollectionPayload.read(params);

        setIsLoader(true);

        try {
            const response: any = await FetchData({ ...payload });
            setData(response.data.data);
            setMeta(response.data.meta);
            setIsLoader(false);
        } catch (error) {
            const { response } = error;
            setData(initialData);
            setMeta(initialMeta);
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };


    const getCountries = async (params: any) => {
        const payload: IFetchData = CountryPayload.read(params);
        setIsLoader(true);
        try {
            const response: any = await FetchData({ ...payload });
            setCountries(response.data.data);
            setIsLoader(false);
        } catch (error) {
            const { response } = error;
            setCountries(initialData);
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const getProvinces = async (params: any) => {
        const payload: IFetchData = ProvincePayload.read(params);
        setIsLoader(true);
        try {
            const response: any = await FetchData({ ...payload });
            setProvinces(response.data.data);
            setIsLoader(false);
        } catch (error) {
            const { response } = error;
            setProvinces(initialData);
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const getCities = async (params: any) => {
        const payload: IFetchData = CityPayload.read(params);
        setIsLoader(true);
        try {
            const response: any = await FetchData({ ...payload });
            setCities(response.data.data);
            setIsLoader(false);
        } catch (error) {
            const { response } = error;
            setCities(initialData);
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const getDetail = async (id: string) => {
        const payload: IFetchData = CollectionPayload.readOne(id);

        setIsLoader(true);

        try {
            const response: any = await FetchData({ ...payload });
            setIsLoader(false);
            setDetail(response.data.data);
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };



    const postData = async (params: any) => {
        const payload: IFetchData = CollectionPayload.post(params);

        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Berhasil',
                duration: 5,
                description: 'Berhasil simpan data',
            });
            history.push({
                pathname: '/user/users',
            });
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal menyimpan data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const updateData = async (params: any, id: string) => {
        const payload: IFetchData = CollectionPayload.put(params, id);

        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Berhasil',
                duration: 5,
                description: 'Berhasil simpan data',
            });
            history.push({
                pathname: '/user/users',
            });
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal menyimpan data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const updateStatus = async (params: any, id: string) => {
        const payload: IFetchData = CollectionPayload.updateStatus(params, id);
        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Berhasil',
                duration: 5,
                description: 'Berhasil merubah status',
            });
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal merubah status",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const deleteData = async (id: string) => {
        const payload: IFetchData = CollectionPayload.delete(id);
        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Success',
                duration: 5,
                description: "berhasil hapus data",
            });
        } catch (error) {
            setIsLoader(false);
            notification.error({
                description: "gagal hapus data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    return {
        data,
        defaultPage,
        getData,
        isLoader,
        setIsLoader,
        postData,
        metaData,
        getDetail,
        updateData,
        deleteData,
        detail,
        getCountries,
        countries,
        getProvinces,
        provinces,
        getCities,
        cities,
        updateStatus
    };
}



// WEBPACK FOOTER //
// ./src/pages/users/hooks/useAction.tsx